import BaseService from "./_base.service";
import { LoadingCost } from "../models/loading.cost";

const endpoint = "loading/cost";

export const LoadingCostService = {
  ...BaseService<LoadingCost>({ endpoint }),
};
